



















































































import {Vue, Component} from 'vue-property-decorator';
import {participantVuexNamespace} from '@/store/participant/const';
import {ChallengeSummary, startChallenge} from '@/services/participant-service';
import {CodeState} from '@/store/participant';
import {requestNotificationPermission, showNotification} from '@/services/notification-service';

@Component
export default class StartChallenge extends Vue {

    @participantVuexNamespace.Getter
    protected challengeSummary!: ChallengeSummary;

    @participantVuexNamespace.Action
    protected saveCodeState!: (codeState: CodeState) => void;

    protected created() {
        requestNotificationPermission();
    }

    protected async start() {
        try {
            this.saveCodeState({
                code: '',
                templateCode: '',
                problemDescription: '',
                questionNumber: 1,
                submitted: false,
                sample: false,
                endTime: null,
                finished: false,
            });
            await startChallenge();
            this.$router.push(`/${this.challengeKey}/challenge`);
        } catch (error) {
            this.$dialog.error({
                text: error.message,
            });
        }
    }

    protected goToSample() {
        this.saveCodeState({
            code: '',
            templateCode: '',
            problemDescription: '',
            questionNumber: 1,
            sample: true,
            submitted: true,
            endTime: null,
            finished: false,
        });
        this.$router.push(`/${this.challengeKey}/sample`);
    }

    protected get challengeKey(): string {
        return this.$route.params.key;
    }
}
